"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogReporter = void 0;
const browser_logs_1 = require("@datadog/browser-logs");
const browser_rum_1 = require("@datadog/browser-rum");
const logger_1 = require("../logger");
const datadogTransport_1 = require("../logger/datadogTransport");
function datadogReporter(info, config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const isLocalhost = window.location.hostname === 'localhost';
    // Don't forward error logs by default, do enable the log transport by default
    // forwardErrorsToLogs incorrectly is called forwardConsoleLogs, this is for backwards compatibility
    const forwardErrorsToLogs = (_a = config.forwardConsoleLogs) !== null && _a !== void 0 ? _a : false;
    const enableLogTransport = config.logTransport !== false;
    // Only init datadog logs if something is using it.
    if (forwardErrorsToLogs !== true && enableLogTransport !== true) {
        browser_logs_1.datadogLogs.init({
            site: config.site,
            proxyUrl: config.proxyUrl,
            clientToken: config.clientToken,
            service: info.service,
            env: info.environment,
            version: (_b = config.version) !== null && _b !== void 0 ? _b : info.version,
            sampleRate: (_c = config.sampleRate) !== null && _c !== void 0 ? _c : 100,
            beforeSend: config.beforeLogsSend,
            useSecureSessionCookie: (_d = config.useSecureSessionCookie) !== null && _d !== void 0 ? _d : !isLocalhost,
            useCrossSiteSessionCookie: (_e = config.useCrossSiteSessionCookie) !== null && _e !== void 0 ? _e : false,
            trackSessionAcrossSubdomains: config.trackSessionAcrossSubdomains,
            forwardErrorsToLogs,
        });
        browser_logs_1.datadogLogs.logger.setHandler(browser_logs_1.HandlerType.http);
    }
    // Add the datadog log transport
    if (enableLogTransport) {
        logger_1.logTransports.push((0, datadogTransport_1.datadogTransport)(typeof config.logTransport === 'boolean' ? {} : config.logTransport));
    }
    browser_rum_1.datadogRum.init({
        site: config.site,
        proxyUrl: config.proxyUrl,
        clientToken: config.clientToken,
        applicationId: config.applicationId,
        service: info.service,
        env: info.environment,
        version: (_f = config.version) !== null && _f !== void 0 ? _f : info.version,
        sampleRate: (_g = config.sampleRate) !== null && _g !== void 0 ? _g : 100,
        replaySampleRate: (_h = config.replaySampleRate) !== null && _h !== void 0 ? _h : 100,
        useSecureSessionCookie: (_j = config.useSecureSessionCookie) !== null && _j !== void 0 ? _j : !isLocalhost,
        useCrossSiteSessionCookie: (_k = config.useCrossSiteSessionCookie) !== null && _k !== void 0 ? _k : false,
        trackSessionAcrossSubdomains: config.trackSessionAcrossSubdomains,
        trackInteractions: (_l = config.trackInteractions) !== null && _l !== void 0 ? _l : false,
        trackFrustrations: (_m = config.trackFrustrations) !== null && _m !== void 0 ? _m : false,
        trackViewsManually: (_o = config.trackViewsManually) !== null && _o !== void 0 ? _o : false,
        actionNameAttribute: (_p = config.actionNameAttribute) !== null && _p !== void 0 ? _p : 'data-analytics-name',
        beforeSend: config.beforeSend,
        defaultPrivacyLevel: (_q = config.defaultPrivacyLevel) !== null && _q !== void 0 ? _q : 'mask-user-input',
        allowedTracingOrigins: config.allowedTracingOrigins,
    });
    const reporter = {
        trackEvent: function (event) {
            browser_rum_1.datadogRum.addAction(event.message, {
                level: event.level,
                ...event.metadata,
                ...event.tags,
                ...event.metrics,
            });
        },
        addBreadcrumb: function (breadcrumb) {
            browser_rum_1.datadogRum.addAction(breadcrumb.message, {
                ...breadcrumb.metadata,
                category: breadcrumb.category,
            });
        },
        addMetadata: function (metadata) {
            for (const [key, value] of Object.entries(metadata)) {
                if (value !== null) {
                    browser_rum_1.datadogRum.addRumGlobalContext(key, value);
                    // Note, this will add duplicate context data in logs.
                    // But this is valuable for logs ingested outside of the browser logger.
                    browser_logs_1.datadogLogs.addLoggerGlobalContext(key, value);
                }
                else {
                    browser_rum_1.datadogRum.removeRumGlobalContext(key);
                    // But this is valuable for logs ingested outside of the browser logger.
                    browser_logs_1.datadogLogs.removeLoggerGlobalContext(key);
                }
            }
        },
        setUser: function (user) {
            var _a;
            if (user) {
                browser_rum_1.datadogRum.setUser({
                    id: user.id,
                    email: user.email,
                    name: (_a = user.name) !== null && _a !== void 0 ? _a : user.email,
                });
            }
            else {
                browser_rum_1.datadogRum.removeUser();
            }
        },
        setRouteName: function (routeName) {
            reporter.addMetadata({ routeName });
        },
        setPageName: function (pageName) {
            if (config.trackViewsManually) {
                browser_rum_1.datadogRum.startView(pageName);
            }
            else {
                reporter.addMetadata({ pageName });
            }
        },
        reportError: function (error, metadata) {
            browser_rum_1.datadogRum.addError(error, metadata);
        },
        recordSession: function () {
            browser_rum_1.datadogRum.startSessionReplayRecording();
        },
        recordSessionStop: function () {
            browser_rum_1.datadogRum.stopSessionReplayRecording();
        },
    };
    return reporter;
}
exports.datadogReporter = datadogReporter;
//# sourceMappingURL=datadogReporter.js.map